module.exports = __webpack_public_path__ + "img/b10.6a825da3.png";